import React from "react";
import { useState } from "react";
import styled from "styled-components";
import { Input } from "../../../../../components/Input/input";
import { theme } from "../../../../../helpers/theme";
import { useAppSelector } from "../../../../../hooks/redux-hooks";
import { ApplicationState } from "../../../../../redux/reducers";
import SessionService from "../../../../../services/session-service";
import {
  GetAllWarehouses,
  GetAllWarehousesPayload,
} from "../../../../../services/warehouses/get-all/types";
import { StyledPopover } from "../../../unlogged-dashboard/form-bar/styled-popover";

interface LocationPopoverProps {
  element: string;
  setElement: (element: string) => void;
}
const OfferLocationPopover = ({
  element,
  setElement,
}: LocationPopoverProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);

  const warehouses = SessionService.getWarehousesList();
  const names = warehouses.map(function (item: GetAllWarehouses) {
    return item.adres.miejscowosc;
  });
  function onlyUnique(value: any, index: any, self: any) {
    return self.indexOf(value) === index;
  }

  const [locations, setLocations] = useState<string[]>(
    names.filter(onlyUnique)
  );

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLocationClick = (item: string) => {
    setElement(item);
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <LocationPopoverContainer>
      {" "}
      <Input
        label="Lokalizacja"
        id="location"
        name="location"
        value={element}
        onClick={(e) => handleClick(e)}
        focused={false}
        variant="filled"
        style={{ width: "100%", caretColor: "transparent" }}
      />
      <StyledPopover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <PopoverContentContainer>
          <LocationWrapper>
            {locations.map((item) => (
              <LocationItem
                key={item}
                onClick={() => handleLocationClick(item)}
              >
                {item}
              </LocationItem>
            ))}
          </LocationWrapper>
        </PopoverContentContainer>
      </StyledPopover>
    </LocationPopoverContainer>
  );
};

export default OfferLocationPopover;

const LocationPopoverContainer = styled.div`
  width: 100%;
`;
const PopoverContentContainer = styled.div`
  padding: 20px;
  width: 300px;
  //height: 100px;
  background-color: white;
`;
const LocationWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;
const LocationItem = styled.div`
  padding: 12px;
  display: flex;
  justify-content: center;
  font-family: ${theme.fonts.interMedium};
  border: 1px solid ${theme.colors.gray02_border};
  border-radius: 10px;
  :hover {
    border: 1px solid ${theme.colors.blue02_hover};
  }
`;
const LocationName = styled.span`
  font-family: ${theme.fonts.interMedium};
  cursor: pointer;
`;
